<div [class]="'main ' + params.column?.colDef?.context?.tableColumn?.styleClass" (click)="sortRequested($event)" [style.height]="params.column?.colDef?.context?.tableColumn?.rotate90 ? params.context?.table?.headerHeight + 'px' : undefined" (click)="click($event)">
    <div *ngIf="params.context.table.useTableMenu && isFirstColumn()" #menuButton class="mr-1 mouse-pointer" (click)="menuClicked($event)"><i class="fas fa-cog"></i>
    </div>
    <div class="customHeaderLabel" [class.rotated-text]="params.column?.colDef?.context?.tableColumn?.rotate90">
        @if(params.column?.colDef?.context?.tableColumn?.keepHtml) {
            <span [innerHTML]="params.displayName | keepHtml"></span>
        }    
        @else {
            {{params.displayName}}
        }
        @if (!_Utils.isNoe(params.column?.colDef?.context?.toolTip)) {
            <i class="fa fa-question" [pTooltip]="params.column?.colDef?.context?.toolTip"></i>
        } 
    </div>    
    <div *ngIf="params.column.isSortAscending()" class="ml-1 active" class="customSortDownLabel">
        <i class="fa fa-long-arrow-alt-down"></i>
    </div>
    <div *ngIf="params.column.isSortDescending()"class="ml-1 active" class="customSortUpLabel">
        <i class="fa fa-long-arrow-alt-up"></i>
    </div>
    <div *ngIf="params.context.table.useColumnMenu" class="menu-button mouse-pointer" (click)="columnMenuClicked($event)">
        <i class="fas fa-bars"></i>
    </div>

</div>
